export const simplonWebsiteUrl = "https://simplon.co";
